import { PLAYPAUSE, CHANGETRACK } from "../../actions/index"

import type { State } from "./playerTypes"
import { EMPTY_TRACK_DATA } from "./playerTypes"

import {
  getStoredTrackData,
  getRandomTrack,
  saveTrackToStorage,
  changeTrack,
} from "./playerHelpers"

/* =========================
   INITIAL STATE
========================= */

const initialTrackData =
  getStoredTrackData() ||
  getRandomTrack() ||
  EMPTY_TRACK_DATA

if (!getStoredTrackData()) {
  saveTrackToStorage(initialTrackData)
}

export const INITIAL_STATE: State = {
  trackData: initialTrackData,
  isPlaying: false,
}

/* =========================
   REDUCER
========================= */

export const reducer = (
  state: State = INITIAL_STATE,
  action: any
): State => {
  switch (action.type) {
    case PLAYPAUSE:
      return {
        ...state,
        isPlaying: action.payload,
      }

      case CHANGETRACK: {
        return changeTrack(state, action.payload)
      }

    /* case CHANGETRACK: {
      const newState = changeTrack(state, action.payload)

      return {
        ...newState,
        isPlaying: true,
      }
    } */

    default:
      return state
  }
}